export default "__VITE_ASSET__CDfbJaxG__"